import I18n from 'i18n-js';
I18n.translations || (I18n.translations = {});
I18n.translations["es"] = I18n.extend((I18n.translations["es"] || {}), {
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "La validación falló: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
          "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
        }
      }
    }
  },
  "check_reservation": {
    "code_text": "Chequear reserva",
    "no_search_params": "No se especificó ningun criterio de búsqueda",
    "reference_incorrect": "No hay ninguna reserva  con No. de referencia: %{reference}",
    "reference_not_found": "No pudimos validar ninguna reserva con No. de referencia: %{reference}, para el Email: %{email}"
  },
  "colors": {
    "bgColor": "Fondo",
    "bgColorSecondary": "Fondo secundario",
    "bgDarkColor": "Fondo Oscuro",
    "btnDisable": "Botón Disabled",
    "btnDisableOpacity50": "Botón Disabled con Opacidad al 50%",
    "btnError": "Botón Error",
    "btnErrorOpacity50": "Botón Error con Opacidad al 50%",
    "btnInfo": "Botón Info",
    "btnInfoOpacity50": "Botón Info con Opacidad al 50%",
    "btnSuccess": "Botón Success",
    "btnSuccessOpacity50": "Botón Success con Opacidad al 50%",
    "btnWarning": "Botón Warning",
    "btnWarningOpacity50": "Botón Warning con Opacidad al 50%",
    "sectionEven": "Sección par",
    "sectionOdd": "Sección inpar",
    "sectionSecondary": "Sección alternativa",
    "txtAlt": "Texto Alterativo",
    "txtC": "Texto",
    "txtDsb": "Texto deshabilitado",
    "txtHighlight": "Primario",
    "txtHighlightOpacity30": "Primario con Opacidad al 30%",
    "txtHighlightOpacity50": "Primario con Opacidad al 50%",
    "txtHighlightOpacity80": "Primario con Opacidad al 80%",
    "txtHighlightSecondary": "Secundario",
    "txtHighlightSecondaryOpacity30": "Secundario con Opacidad al 30%",
    "txtHighlightSecondaryOpacity50": "Secundario con Opacidad al 50%",
    "txtHighlightSecondaryOpacity80": "Secundario con Opacidad al 80%"
  },
  "date": {
    "abbr_day_names": [
      "dom",
      "lun",
      "mar",
      "mié",
      "jue",
      "vie",
      "sáb"
    ],
    "abbr_month_names": [
      null,
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic"
    ],
    "day_names": [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado"
    ],
    "formats": {
      "default": "%-d/%-m/%Y",
      "long": "%-d de %B de %Y",
      "short": "%-d de %b"
    },
    "month_names": [
      null,
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "alrededor de %{count} hora",
        "other": "alrededor de %{count} horas"
      },
      "about_x_months": {
        "one": "alrededor de %{count} mes",
        "other": "alrededor de %{count} meses"
      },
      "about_x_years": {
        "one": "alrededor de %{count} año",
        "other": "alrededor de %{count} años"
      },
      "almost_x_years": {
        "one": "casi %{count} año",
        "other": "casi %{count} años"
      },
      "half_a_minute": "medio minuto",
      "less_than_x_minutes": {
        "one": "menos de %{count} minuto",
        "other": "menos de %{count} minutos"
      },
      "less_than_x_seconds": {
        "one": "menos de %{count} segundo",
        "other": "menos de %{count} segundos"
      },
      "over_x_years": {
        "one": "más de %{count} año",
        "other": "más de %{count} años"
      },
      "x_days": {
        "one": "%{count} día",
        "other": "%{count} días"
      },
      "x_minutes": {
        "one": "%{count} minuto",
        "other": "%{count} minutos"
      },
      "x_months": {
        "one": "%{count} mes",
        "other": "%{count} meses"
      },
      "x_seconds": {
        "one": "%{count} segundo",
        "other": "%{count} segundos"
      },
      "x_years": {
        "one": "%{count} año",
        "other": "%{count} años"
      }
    },
    "prompts": {
      "day": "Día",
      "hour": "Hora",
      "minute": "Minuto",
      "month": "Mes",
      "second": "Segundo",
      "year": "Año"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "debe ser aceptado",
      "blank": "no puede estar en blanco",
      "confirmation": "no coincide",
      "empty": "no puede estar vacío",
      "equal_to": "debe ser igual a %{count}",
      "even": "debe ser par",
      "exclusion": "está reservado",
      "greater_than": "debe ser mayor que %{count}",
      "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
      "in": "debe estar en %{count}",
      "inclusion": "no está incluido en la lista",
      "invalid": "no es válido",
      "less_than": "debe ser menor que %{count}",
      "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
      "model_invalid": "La validación falló: %{errors}",
      "not_a_number": "no es un número",
      "not_an_integer": "debe ser un entero",
      "odd": "debe ser impar",
      "other_than": "debe ser distinto de %{count}",
      "present": "debe estar en blanco",
      "required": "debe existir",
      "taken": "ya está en uso",
      "too_long": {
        "one": "es demasiado largo (%{count} carácter máximo)",
        "other": "es demasiado largo (%{count} caracteres máximo)"
      },
      "too_short": {
        "one": "es demasiado corto (%{count} carácter mínimo)",
        "other": "es demasiado corto (%{count} caracteres mínimo)"
      },
      "wrong_length": {
        "one": "no tiene la longitud correcta (%{count} carácter exactos)",
        "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
      }
    },
    "template": {
      "body": "Se encontraron problemas con los siguientes campos:",
      "header": {
        "one": "No se pudo guardar este/a %{model} porque se encontró %{count} error",
        "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
      }
    }
  },
  "errors_page": {
    "internal_server_error": "Al parecer hubo un error en el servidor, inténtelo más tarde",
    "locked": "Este recurso está bloqueado.",
    "not_accepted": "Hemos detectado que está usando un servidor proxy para acceder a nuestra web",
    "not_found": "La página solicitada no existe o puede que el enlace este roto",
    "unprocessable_entity": "La acción no se pudo procesar correctamente debido a que se proporcionaron datos no válidos"
  },
  "global": {
    "admin": {
      "ch": "Chino",
      "de": "Alemán",
      "en": "Inglés",
      "es": "Español",
      "fr": "Frances",
      "it": "Italiano",
      "pt": "Portugues",
      "ru": "Ruso"
    },
    "footer": {
      "contact": "Contacto",
      "faqs": "Preguntas frecuentes",
      "information": "Información",
      "privacy_policy": "Política de Privacidad y Uso de Cookies",
      "term_and_conditions": "Términos y condiciones"
    },
    "in_maintenance": {
      "content": "Estamos en mantenimiento. Volveremos pronto",
      "icon": ":(",
      "not_acceptable": "Petición no aceptada.",
      "title": "¡Lamentamos las molestias!"
    },
    "loader": "Cargando...",
    "main": {
      "form": {
        "button": "Buscar",
        "errors": {
          "field_empty": "Este campo no puede estar vacío"
        },
        "message": {
          "checking_availability": "Comprobando la disponibilidad del servicio solicitado...",
          "create_shopping_cart": "Validando datos de la reserva...",
          "load_products": "Cargando productos",
          "loading_data": "Cargando datos, espere por favor...",
          "loading_offices": "Cargando oficinas disponibles...",
          "no_availability": "No hay disponibilidad para el servicio solicitado.",
          "request_error": "No se pudo completar la operación. Verifique su conexión e intente de nuevo.",
          "request_error_title": "Error de conexión",
          "reservation_error_title": "No se pudo completar la reserva",
          "search_contract": "Buscando contrato de reserva...",
          "search_modality": "Buscando modalidad de reserva...",
          "search_tariff": "Buscando tarifa de reserva...",
          "timeout_error": "El servicio no responde. Intente de nuevo en unos minutos."
        },
        "select_category": "Seleccione una categoría",
        "select_destiny": "Seleccione un destino",
        "select_drop_off_location": "Seleccione un punto de destino",
        "select_home": "Seleccione una casa",
        "select_modality": "Seleccione una modalidad",
        "select_office": "Seleccione una oficina",
        "select_pick_up_location": "Seleccione un punto de recogida",
        "select_service": "Seleccione un servicio",
        "work_all_day": "Esta oficina trabaja 24 horas.",
        "work_by_hours": "Esta oficina trabaja en el horario de %{from} a %{to} "
      },
      "info": "Ver detalles",
      "read_more": "Leer más..."
    },
    "online_asistan": "Asistencia en linea",
    "popup": {
      "cancel_rent_cancel": "No, continuar con mi reserva",
      "cancel_rent_confirm": "Si, cancelar",
      "create_shopping_cart_confirm": "Entendido",
      "product_no_disponibility_confirm": "Entendido",
      "verify_email_confirm": "Validar",
      "verify_email_in_process_confirm": "Entendido",
      "verify_login_for_rent_cancel": "Cancelar",
      "verify_login_for_rent_cancel_confirm": "Entendido",
      "verify_login_for_rent_confirm": "Iniciar sesión",
      "verify_login_for_rent_denied": "Registrarme",
      "with_rent_cancel": "No, continuar con el antiguo",
      "with_rent_confirm": "Si, deseo continuar",
      "with_rent_in_pay_process_cancel": "No deseo continuar",
      "with_rent_in_pay_process_cancel_confirm": "Entendido",
      "with_rent_in_pay_process_confirm": "Si, deseo continuar",
      "with_rent_redirect_to_pay_confirm": "Si, deseo continuar",
      "with_rent_redirect_to_paycancel": "No, Cancelar la reserva",
      "without_rent_confirm": "Entendido"
    },
    "section_an_page": {
      "accreditation": "Acreditaciones disponibles (%{count})",
      "back": "Regresar",
      "back_to_home": "Regresar al inicio",
      "doc": "Descarga nuestro programa",
      "doc_btn": "Descargar PDF",
      "events": "Eventos",
      "go_to_admin": "Ir a la administración",
      "no_events": "No hay eventos disponibles por el momento",
      "no_notices": "No hay noticias disponibles por el momento",
      "notices": "Noticias",
      "print": "Imprimir",
      "show_accreditation": "Ver acreditaciones"
    },
    "slogan": "Ecotur S.A.",
    "time": {
      "centuries": "Siglo (s)",
      "day": "Days",
      "hours": "Hora (s)",
      "hrs": "Hours",
      "minutes": "Minutos",
      "months": "Mes (es)",
      "seconds": "Segundos",
      "years": "Año (s)"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Por favor seleccione"
    },
    "submit": {
      "create": "Crear %{model}",
      "submit": "Guardar %{model}",
      "update": "Actualizar %{model}"
    }
  },
  "histories": {
    "accreditation": {
      "accreditation_for_book": "Acreditaciones para la reserva %{ref}",
      "accreditation_new": "Nueva acreditación",
      "accreditation_save": "Acreditar",
      "accreditation_save_and_continue": "Acreditar y continuar",
      "accreditation_save_and_send": "Acreditar y enviar por correo",
      "accreditation_with_user_data": "Usar mis datos de usuario",
      "available": "Acreditaciones disponibles (%{count})",
      "available_register": "Inscripciones disponibles (%{count})",
      "not_accreditation": "No hay acreditaciones para mostrar.",
      "registration": "Inscripciones por Correo Electrónico (%{count})",
      "registration_for_book": "Inscripciones para la reserva %{ref}",
      "registration_new": "Nueva inscripción",
      "registration_save": "Inscribir",
      "registration_save_and_continue": "Inscribir y continuar",
      "registration_save_and_send": "Inscribir y enviar por correo",
      "send_all": "Enviar todas las acreditaciones"
    },
    "check_reservation": {
      "address": "Dirección",
      "client": "Cliente",
      "comment": "Observaciones",
      "create_at": "Creado",
      "days": "Días",
      "droppof_place": "Lugar de entrega",
      "email": "Correo electrónico",
      "from": "Fecha",
      "name_last_name": "Nombre(s) y Apellidos",
      "pickup_place": "Lugar de recogida",
      "price": "Precio",
      "product": "Producto",
      "product_name": "Nombre",
      "quantity": "Cantidad",
      "reference_number": "No. Referencia",
      "reservation_status": "Estado de la reserva",
      "status_cancel": "Cancelada",
      "status_confirmation": "Confirmada",
      "status_in_confirmation": "En confirmación",
      "status_modify": "Modificada",
      "to": "Hasta",
      "total_price": "Precio total"
    }
  },
  "home": {
    "page": {
      "all": "Todas",
      "clean_filters": "Limpiar Filtros",
      "fewest_rooms": "Menos habitaciones",
      "filter_home": "Filtrar casas",
      "highest_price": "Precio (mayor a menor)",
      "house_card": {
        "book_now": "Reservar Ahora",
        "location": "La Habana, Cuba",
        "night": "noche",
        "no_description": "Sin descripción",
        "status": "Disponible"
      },
      "lowest_price": "Precio (menor a mayor)",
      "most_rooms": "Más habitaciones",
      "name_a_z": "Nombre (A-Z)",
      "name_z_a": "Nombre (Z-A)",
      "one_room": "habitación",
      "price_night": "Precio por noche",
      "select_range_date": "Selecciona un rango de fechas",
      "show_x_homes": "Mostrando %{count} casas disponibles",
      "some_room": "habitaciones",
      "sort_by": "Ordenar por",
      "subtitle": "Encuentra la casa perfecta para tu estancia en Cuba",
      "title": "Renta de Casas en Cuba"
    }
  },
  "hotetec": {
    "hotel": {
      "can_other_booking": "Puede realizar otra reserva",
      "cancel_booking": "Reserva cancelada satisfactoriamente.",
      "error_add_room": "Un error impidió agregar la habitación al carrito virtual. Contacte con la administración.",
      "error_cancel_booking": "Un error impidió cancelar la reserva. Contacte con la administración.",
      "error_cheking_avail": "Un error impidió consultar la disponibilidad. Contacte con la administración.",
      "error_complete_booking": "Un error impidió completar la reserva. Contacte con la administración.",
      "error_confirm_booking": "Un error impidió confirmar la reserva. Contacte con la administración.",
      "error_remove_room": "Un error impidió remover la habitación del carrito virtual. Contacte con la administración.",
      "hotel_not_found": "Hotel no encontrado",
      "invalid_export_format": "Formato de exportación no válido",
      "many": "%{count} Hoteles",
      "missing_parameters": "Faltan parámetros en su petición",
      "not_data_cancel_booking": "No existen datos para cancelar la reserva.",
      "not_data_complete_booking": "No existen datos para completar la reserva.",
      "not_data_confirm_booking": "No existen datos para confirmar la reserva.",
      "not_data_remove_room": "No existen datos para remover habitación del carrito virtual.",
      "not_search": "No se pudo buscar...",
      "not_section_hotel": "No existe en la sección los datos del hotel.",
      "num_rooms": "Número de habitaciones",
      "one": "%{count} Hotel",
      "range_date": "Fechas",
      "range_date_placeholder": "Llegada / Salida",
      "rooms": "Habitaciones",
      "search": "Buscar",
      "search_avail": "Buscando Disponibilidad",
      "section_not_started": "No ha iniciado la sección",
      "select_hotel": "Selecciona un hotel",
      "select_range_date": "Selecciona fechas",
      "session_open": "Sección abierta",
      "session_open_already": "Ya tiene la sección abierta",
      "text": "Hotel",
      "waiting_time_expired": "Tiempo de espera agorado."
    },
    "payment": {
      "not_payment_method": "No existe el método de pago."
    },
    "virtual_card": {
      "cancellation_mode": "Política de cancelación",
      "cancellation_mode_non_refundable": "No reembolsable",
      "cancellation_mode_period_free_cancellation": "Cancelación gratuita",
      "currency": "Moneda",
      "distribution": "Distribución",
      "occupation": "Ocupación",
      "price": "Importe",
      "rate": "Tarifa",
      "reference": "Referencia",
      "room": "Habitación",
      "room_cancel": "Cancelar Reserva",
      "room_canceling": "Cancelando Reserva",
      "room_complete": "Completar Reserva",
      "room_completing": "Completando Reserva",
      "room_confirm": "Confirmar Reserva",
      "room_confirming": "Confirmando Reserva",
      "room_remove": "Remover Habitación",
      "room_removing": "Removiendo Habitación",
      "status": "Estado",
      "status_cancelled": "Cancelada",
      "status_confirmed": "Confirmada",
      "total_price": "Importe Total"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    },
    "transliterate": {
      "rule": {
        "Á": "A",
        "É": "E",
        "Í": "I",
        "Ñ": "N",
        "Ó": "O",
        "Ú": "U",
        "Ü": "U",
        "á": "a",
        "é": "e",
        "í": "i",
        "ñ": "n",
        "ó": "o",
        "ú": "u",
        "ü": "u"
      }
    }
  },
  "login_and_register": {
    "email_validate": {
      "invalid_token": "El token proporcionado no se encuentra o ha expirado, contacto con un administrador.",
      "request_validate_no_authenticated": "Debe de autenticarse para poder validar su correo",
      "request_validate_token": "Se le ha enviado un mensaje de validación al correo <strong>%{email}</strong>, por favor siga las instrucciones del mismo para validar su cuenta.<br><hr><small>Si no aparece en su bandeja de entrada, revise la carpeta de spam.</small>",
      "request_validate_token_error": "Ha ocurrido un error al enviar el correo, inténtelo más tarde, si el error persiste.<br> <strong>Contacte con un administrador</strong>",
      "title": "Validación de Email",
      "validate_error": "Ha ocurrido un error y su cuenta no se ha podido validar, inténtelo más tarde o pongase en contacto con un administrador.",
      "validate_successfully": "<p>Estimado(a) <strong>%{name}</strong></p><br>Su cuenta fue validada correctamente!!!",
      "validate_token": "<p>Estimado(a) %{name}. <br>Su cuenta fue validada anteriormente, no es necesario realizar la accción.</p>"
    },
    "forgot_my_password": {
      "email": "Correo electrónico",
      "helper": "Por favor introduzca su dirección de correo",
      "send_btn": "Enviar",
      "title": "Olvide mi contraseña"
    },
    "login": {
      "dont_have_account": "No tengo una cuenta aún",
      "email": "Correo electrónico",
      "forgot_my_password": "Olvidé mi contraseña",
      "login_message_error": "Usuario o Contraseña incorrecto",
      "login_message_error_api": "Este usuario no puede acceder al sistema (Contacte con la administración)",
      "password": "Contraseña",
      "remember_me": "Recuérdame",
      "title": "Iniciar sesión"
    },
    "password_reset": {
      "can_change_password": "Puede cambiar su contraseña",
      "change_password": "Cambiar contraseña",
      "change_password_invalid": "Solicitud invalida.",
      "change_password_time_expire": "Ha expirado el tiempo para cambiar su contraseña.",
      "email_incorrect": "Error al generar el token temporal para el reestablecimeinto de su contraseña",
      "email_send_error": "No podemos avalar que su correo se encuentre en nuestro sitio",
      "email_send_success": "Se a enviado un correo con los datos para reestabler su contraseña",
      "password_change_error": "Ocurrio un problema al cambiar la contraseña, intente de nuevo.",
      "password_change_successfully": "Su contraseña fue modificada correctamente",
      "password_confirm_field": "Confirmar Contraseña",
      "password_field": "Contraseña",
      "save_btn": "Cambiar contraseña",
      "title": "Solicitud de cambio de contraseña"
    },
    "register": {
      "additional_comments": "Comentarios adicionales",
      "address": "Dirección",
      "allergic_food": "¿Es alérgico a algún alimento? ¿Cuáles?",
      "checkbox": "Registrarme e Iniciar sesión",
      "ci": "Número de Identificación (DNI, Pasaporte, etc.)",
      "city": "Ciudad",
      "country": "País",
      "date_of_birth": "Fecha de Nacimiento",
      "digital_certif_part": "¿Está interesado en recibir Certificado de Participación Digital?",
      "email": "Correo electrónico",
      "expectations": "Expectativas del Evento",
      "expectations_2": "¿Qué espera aprender o lograr en este evento?",
      "experience_rural_t": "Experiencia previa en Turismo Rural",
      "food_preferences": "¿Preferencias alimentarias? (Marque lo que aplique)",
      "how_find_about_event": "¿Cómo se enteró del evento?",
      "institution": "Empresa o Institución que representa",
      "last_name": "Apellidos",
      "login_btn": "Ir a Iniciar sesión",
      "name": "Nombre",
      "nationality": "Nacionalidad",
      "occupation": "Ocupación",
      "office_phone": "Teléfono de Oficina",
      "particip_modality": "Modalidad de Participación",
      "passport": "CI o Pasaporte",
      "password": "Contraseña",
      "password_confirm": "Confirmar contraseña",
      "phone_numbre": "Télefono",
      "position_held": "Cargo que desempeña",
      "reason_for_part_event": "Motivo de participación en el evento",
      "sector": "Sector",
      "send_btn": "Registrarme",
      "social_networks": "Redes sociales (usuario)",
      "title": "Registrarme"
    }
  },
  "mailer": {
    "email_validate": {
      "email_btn": "Validar coreo electrónico",
      "helper": "Si tiene alguna pregunta, simplemente contáctenos a través del siguiente correo, siempre es un placer ayudar",
      "text": "Usted proporciono un correo electrónico para iniciar sesión en nuestro sistema y es necesario validar que es un correo electrónico activo, para validar su cuenta, por favor haga click en el siguiente botón",
      "thanks": "Gracias por preferir nuestros servicios",
      "title": "Estimado(a) %{user}"
    },
    "password_change": {
      "reset_btn": "Recuperar contraseña",
      "text": "Le enviamos este correo porque usted solicito un cambio de contraseña, para validar que ha sido usted y cambiar la contraseña de su cuenta haga click en el siguiente botón",
      "title": "Estimado(a) %{user}"
    },
    "registration": {
      "btn_registration": "Inscribirme",
      "text": "Se le informa que mediante el enlace de abajo usted puede registrarse en el evento: %{event_name}",
      "text_create": "Se le informa que ha sido inscrito en el evento: %{event_name}",
      "title": "Estimado(a):",
      "title_create": "Estimado(a) %{user}"
    }
  },
  "main": {
    "body": {
      "catalog": {
        "add_to_cart": "Adicionar al carrito",
        "cancellation_time": "Tiempo de antelación para cancelar: %{days} días",
        "description": "Descripción",
        "from": "Desde",
        "modality_description": "Descripción de la modalidad",
        "other_products": "Otros productos que puedan ser de tu interes",
        "price_tag": "Precio referencial desde: %{price} EUR",
        "rent_btn": "Reservar",
        "reservation_time": "Tiempo de antelación para reservar: %{days} días",
        "title": "Catálogo de productos"
      },
      "read_more": "Leer más..."
    },
    "cookies_box": {
      "button": "Estoy de acuerdo",
      "description": "Almacenamos datos temporalmente para mejorar su experiencia de navegación y recomendarle contenido de interés. Al utilizar nuestros servicios, aceptas dicho seguimiento.",
      "title": "Este sitio web usa cookies"
    },
    "header": {
      "admin": "Administración",
      "agency": "Agencia",
      "check_reservation": {
        "button": "Chequear",
        "email": "Correo electrónico",
        "no_reference": "No. de referencia",
        "title": "Chequear reserva"
      },
      "commercial": "Administración comercial",
      "login": "Acceder",
      "logout": "Salir",
      "profile": "Mi perfil",
      "register": "Registrarse",
      "shopping_cart": {
        "accept_btn": "Continuar",
        "adding_product": "Añadiendo producto al carrito",
        "cancel_btn": "Cancelar",
        "canceling_shopping_cart": "Cancelando carrito de compras",
        "category": "Categoría",
        "could_not_add_product": "No se pudo añadir el producto",
        "could_not_store_pre_order": "No se pudo almacenar la pre-reserva",
        "destiny": "Destino",
        "drop_date": "Fecha de entrega",
        "generating_payment_link": "Generando enlace de pago",
        "load_products": "Cargando productos del carrito",
        "not_product_added": "No se ha podido añadir el producto al carrito",
        "pick_date": "Fecha de recogida",
        "price": "Precio",
        "product_added": "Producto añadido correctamente",
        "product_deleted": "Producto eliminado",
        "removing_product": "Eliminando producto del carrito",
        "selling_contract": "Contrato de venta",
        "selling_contract_text": "No se pudo determinar un contrato de venta",
        "selling_price": "Tarifa de venta",
        "selling_price_text": "No se pudo determinar una tarifa de venta",
        "shopping_cart": "Carrito de compras",
        "shopping_cart_cancelled": "Carrito de compras cancelado",
        "status_payment_gateway": "Verificando estado de la pasarela de pago",
        "terms_conditions": "Términos y condiciones",
        "terms_conditions_text": "Debe aceptar nuestros términos y condiciones para continuar",
        "time_elapse": "Tiempo restante",
        "title": "Producto en carrito",
        "verified_payment_gateway": "Pasarela de pago verificada",
        "verifying_purchase_data": "Verificando datos de compra"
      }
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "mil millones",
          "million": {
            "one": "millón",
            "other": "millones"
          },
          "quadrillion": "mil billones",
          "thousand": "mil",
          "trillion": {
            "one": "billón",
            "other": "billones"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n %"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pre_reservations": {
    "category": "Categoría",
    "product_description": "Descripción del producto"
  },
  "privacy_policy": {
    "title": "Política de Privacidad"
  },
  "profile": {
    "my_reservations": {
      "last_reservations": "%{count} últimas rentas",
      "last_reservations_one": "Última renta",
      "price": "Precio",
      "product": "Producto",
      "reference": "No. Referencia",
      "status": "Estado",
      "title": "Mis reservaciones",
      "type": "Tipo"
    },
    "profile": {
      "address": "Dirección",
      "avatar": "Avatar",
      "avatar_info_edit": "JPG or PNG no mayor de 1MB",
      "city": "Ciudad",
      "country": "País",
      "details": "Detalles de la cuenta",
      "edit_btn": "Editar detalles de la cuenta",
      "email": "Correo electrónico (Para acceder al sitio)",
      "email_invalid": "Validar",
      "email_valid": "Validado",
      "name": "Nombre (Cómo aparecerá su nombre en el sitio)",
      "passport": "CI o Pasaporte",
      "phone": "Teléfono",
      "surname": "Apellidos",
      "title": "Perfil"
    },
    "profile_save_success": "Perfil modificado",
    "security": {
      "change_password": "Cambiar contraseña",
      "confirm_new_password": "Confirmar nueva contraseña",
      "new_password": "Nueva contraseña",
      "notice_password_change_error": "Contraseña anterior incorrecta",
      "notice_password_change_success": "Contraseña modificada",
      "old_password": "Contraseña anterior",
      "title": "Seguridad"
    }
  },
  "reservation": {
    "main": {
      "action_btn": {
        "finish": "Pagar",
        "next": "Siguiente",
        "prev": "Anterior"
      },
      "steps": {
        "four": "Datos del Pago",
        "one": "Conductor titular",
        "three": "Términos y condiciones",
        "two": "Datos extra"
      },
      "steps_body": {
        "four": {
          "checking_gateway": "Verificando estado de pasarela...",
          "payment_gateway": "Pasarela de pago en linea",
          "proccesing_pay": "Procesando datos...",
          "title": "Método de pago"
        },
        "one": {
          "address": "Dirección",
          "city": "Ciudad",
          "country": "País",
          "email": "Correo electrónico",
          "name": "Nombre(s)",
          "passport": "Pasaporte",
          "surname": "Apellidos"
        },
        "three": {
          "accept_terms": "Acepto los términos y condiciones"
        },
        "two": "Datos extras"
      },
      "title": "Datos de la reserva"
    },
    "product": {
      "home": {
        "adult": "Adultos",
        "children": "Niños",
        "max_capacity": "Capacidad máxima",
        "room": "Habitaciones"
      }
    },
    "side_bar": {
      "active_reservation": "Reserva",
      "add_product": "Adicionar producto",
      "add_product_mobile": "Adicionar",
      "adults": "Adultos",
      "alojam": "Alojamiento",
      "amount": "Cantidad",
      "assistance": "Asistencia",
      "brand": "Marca",
      "buggy": "Buggy",
      "cancel_reservation_btn": "Cancel shopping cart",
      "cancel_reservation_mobile_btn": "Cancel",
      "category": "Categoría",
      "children": "Niños",
      "confirm_cart": "Proceder al pago",
      "confirm_cart_mobile": "Pagar",
      "date": "Fecha",
      "dates": "Fechas",
      "dealer": "Prestatario",
      "delete_product": "Eliminar producto",
      "delete_product_mobile": "Eliminar",
      "departure_from": "Salida desde",
      "departure_zone": "Zona de Salida",
      "destiny": "Destino",
      "drop_off_location": "Punto de Destino",
      "dropoff_date": "Fecha de entrega",
      "dropoff_date_time": "Fecha/Hora de entrega",
      "dropoff_time": "Hora de entrega",
      "event_type": "Tipo de evento",
      "home": "Casa",
      "lang": "Idioma",
      "modality": "Modalidad",
      "model": "Modelo",
      "payment_method": "Método de pago",
      "person_amount": "Personas",
      "pick_up_location": "Punto de Recogida",
      "pickup_date": "Fecha de recogida",
      "pickup_date_time": "Fecha/Hora de recogida",
      "pickup_place": "Recogida en",
      "pickup_place_description": "Especifique lugar en que se encuentra ó Punto de recogida",
      "pickup_time": "Hora de recogida",
      "price": "Precio",
      "price_by_person": "Precio x persona",
      "price_by_room": "Precio x habitación",
      "product": "Producto",
      "rooms": "Habitaciones",
      "rooms_count": "Cantidad de habitaciones",
      "service": "Servicio",
      "time_elapse": "Tiempo restante",
      "total_price": "Total a pagar",
      "transfers": "Traslados",
      "update_product": "Actualizar producto",
      "update_product_mobile": "Actualizar"
    }
  },
  "support": {
    "array": {
      "last_word_connector": " y ",
      "two_words_connector": " y ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%A, %-d de %B de %Y %H:%M:%S %z",
      "long": "%-d de %B de %Y %H:%M",
      "short": "%-d de %b %H:%M"
    },
    "pm": "pm"
  }
});
